@if (!isLoaded) {
  <app-tdo-progress-spinner data-cy="io-gallery-spinner"></app-tdo-progress-spinner>
}
<ngx-gallery (imagesReady)="onDataLoaded($event)" style="height: 100%;" class="normal-z" [options]="galleryOptions" [images]="galleryImages" data-cy="io-gallery-container">
</ngx-gallery>
